export const MAX_COLUMN_WIDTH = 12;

export const ONE_THIRD_OF_COLUMN_WIDTH = 4;

export const QUARTER_OF_COLUMN_WIDTH = 3;
